// File for all constants/enumerations, etc.

// Use 'name' for all official purposes (kind of like an id)
export const ClickupStatuses = {
  activation: {
    name: 'provisioned boron',
    displayName: 'Provisioned Boron',
    colour: '#f9d900',
  },
  pairedDoorSensor: {
    name: 'paired door sensor',
    displayName: 'Paired Door Sensor',
    color: '#ff7800',
  },
  tested: {
    name: 'tested',
    displayName: 'Tested',
    colour: '#EA80FC',
  },
  registeredToClient: {
    name: 'registered to client',
    displayName: 'Registered to Client',
    colour: '#81B1FF',
  },
  addedToDatabase: {
    name: 'added to database',
    displayName: 'Added to Database',
    colour: '#6bc950',
  },
}

export const Environments = {
  prod: {
    name: 'production',
    displayName: 'Production',
  },
  dev: {
    name: 'development',
    displayName: 'Development',
  },
  staging: {
    name: 'staging',
    displayName: 'Staging',
  },
  default: {
    name: 'development',
    displayName: 'Development',
  },
}
